<!-- This is the little blue "loading..." bar that shows up on top. -->
@if (loading$ | async) {
  <div id="loading" class="shadow-sm rounded px-2 py-1 mx-auto mt-2">
    <div class="me-2" id="spinner"></div>
    <span i18n>Loading</span>
  </div>
}

@if (showPlanExpirationMessage$ | async) {
  <div
    class="alert border-0 m-0 rounded-0 text-center"
    [ngClass]="expTense === ExpTense.Past ? 'alert-danger' : 'alert-warning'"
  >
    <p class="m-2" i18n>
      Your <strong>Trial Plan</strong> {{ expTense }} on {{ trialExpiresOn | date: 'longDate' }}.
      Please contact sales to continue using the full feature set of Copado Robotic Testing.
    </p>
  </div>
}
